import React from "react";
import loading from "../../assets/loading.svg";
import '../../App.css'

const Loading = () => (
  <div className="spinner">
    <img className="loadingImg" src={loading} alt="Loading" />
  </div>
);

export default Loading;